<template>
	<div class="px-4">
		<div class="flex w-full justify-center grid grid-cols-1">
			<div class="flex w-full justify-center grid grid-cols-1 divide-y divide-ihh-midnight-gray/10">
				<div class="w-full max-w-8xl py-12 border-ihh-midnight-gray/30" v-for="review in displayedReviews" :key="review.id">
					<div class="flex w-full justify-around">
						<div class="flex w-full justify-around text-ihh-midnight-gray uppercase font-bold text-sm md:text-base tracking-wide line-clamp-2 md:line-clamp-1">
							<div class="flex w-full justify-start m-auto">
								<Stars :stars="review.rating" />
							</div>
						</div>

						<div class="flex w-full justify-end m-auto text-sm sm:text-base">
							<div class="flex items-start justify-start space-x-3 whitespace-nowrap">
								<div class="text-ihh-midnight-gray capitalize">{{ review.name || 'Annonymous' }}</div>
								<div class="text-ihh-midnight-gray m-auto">|</div>
								<div class="text-gray-600 capitalize">{{ elapsedTime(review.date_reviewed || review.dateModified || review.updated) }}</div>
							</div>
						</div>
					</div>

					<div class="line-clamp-2 md:line-clamp-1 flex w-full justify-start text-ihh-midnight-gray font-semibold text-base md:text-xl tracking-wide pt-2 pb-1">
						{{ review.title }}
					</div>

					<blockquote class="text-start text-ihh-midnight-gray/80 text-sm">
						<div>"{{ review.text }}"</div>
					</blockquote>
				</div>
			</div>
			<div v-if="!showAll && reviews.length > 5" class="flex w-full justify-center py-8">
				<button
					@click="showAll = true"
					class="text-sm text-ihh-midnight-gray border-2 border-ihh-salmon px-8 py-3 rounded-lg hover:bg-ihh-salmon duration-100 font-semibold"
				>
					Show All {{ reviews.length }} Reviews
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Stars from '../../partials/stars.vue'

export default {
	components: { Stars },
	props: {
		reviews: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			showAll: false,
			showReview: false,
			showDropdown: false,
			reportReview: false,
		}
	},
	computed: {
		displayedReviews() {
			return this.showAll ? this.reviews : this.reviews.slice(0, 5)
		},
		elapsedTime() {
			return (creation) => {
				const creationDate = new Date(creation)

				// Define a function to format the date in the desired way
				const formatDate = (date) => {
					if (isNaN(date.getTime())) return ''
					const day = date.getDate()
					// getMonth() avoids Intl/toLocaleString, which can throw "Invalid time zone: undefined"
					// in environments where the runtime can't resolve a default time zone (IHH-FRONT-NEW-BK).
					const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][date.getMonth()]
					const year = date.getFullYear()

					// Add suffix to the day
					const daySuffix = (day) => {
						if (day > 3 && day < 21) return 'th'
						switch (day % 10) {
							case 1:
								return 'st'
							case 2:
								return 'nd'
							case 3:
								return 'rd'
							default:
								return 'th'
						}
					}

					return `${day}${daySuffix(day)} ${month} ${year}`
				}

				return formatDate(creationDate)
			}
		},
	},
	methods: {
		toggleDropdown() {
			this.showDropdown = !this.showDropdown
		},
		handleOptionClick(option) {
			// Handle the option click logic here
			console.log(`Option clicked: ${option}`)
			// You can add further logic based on the selected option
		},
	},
}
</script>
